module.exports = __webpack_public_path__ + "assets/8f0e8cd63322d4fea56403d5457545b3.png";